import { Stack, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/**
 * The opening of every companion card: what happened, and why the brand is
 * being told about it.
 *
 * There is no icon and no kind label. The title already names the subject and
 * the call to action names the destination, so a tile and a category word only
 * cost width in a panel that has none to spare.
 */

interface CompanionCardHeaderProps {
  title: string;
  /** Absent when the title already is the whole sentence. */
  reason?: string;
  /** A line above the title. Only the cards carrying a deadline pass one. */
  eyebrow?: ReactNode;
  /** Anything the card states right under its reason, before the evidence. */
  children?: ReactNode;
}

export const CompanionCardHeader = ({
  title,
  reason,
  eyebrow,
  children,
}: CompanionCardHeaderProps) => (
  <Stack gap="4px" minW={0}>
    {eyebrow}
    <Text
      fontFamily="heading"
      fontSize="16px"
      fontWeight="700"
      letterSpacing="-0.015em"
      color="ink"
      lineHeight="1.3"
    >
      {title}
    </Text>
    {reason ? (
      <Text fontSize="13.5px" color="inkMuted" lineHeight="1.45">
        {reason}
      </Text>
    ) : null}
    {children}
  </Stack>
);
